// Parish-wide constants

export const PARISH = {
    name: "Holy Trinity Catholic Church",
    fullTitle: "Holy Trinity Catholic Church – Kileleshwa Parish Community",
    subtitle: "Archdiocese of Nairobi",
    motto: "Empowered and Sent",
    location: "Kileleshwa",
    fullName: "Holy Trinity Catholic Church, Kileleshwa Parish Community",
    tagline: "A Community of Love, Unity and Service",
    acronym: "COLUS",
    address: {
        line1: "Othaya Road, Kileleshwa",
        line2: "P.O. Box 25732-00603, Nairobi, Kenya",
    },
    addressShort: "Othaya Road, Kileleshwa, Nairobi",
    phone: "0799 651 047",
    phoneRaw: "+254799651047",
    emails: {
        info: "info@holytrinitykileleshwa.org",
        priest: "parishpriest@holytrinitykileleshwa.org",
        catechist: "catechist@holytrinitykileleshwa.org",
    },
    mapUrl:
        "https://www.google.com/maps?ll=-1.282222,36.780278&z=16&t=m&hl=en&gl=US&mapclient=embed&cid=2305948697750083892",
    mapEmbed:
        "https://www.google.com/maps?q=Holy+Trinity+Catholic+Church+Kileleshwa&z=16&output=embed",
    socials: {
        youtube: "https://www.youtube.com/@HolyTrinityCatholicChurchKile",
        facebook: "https://www.facebook.com/HolyTrinityKileleshwa/",
        instagramParish: "https://www.instagram.com/holytrinitykile/",
        instagramYouth: "https://www.instagram.com/holytrinitykileleshwa_youth/",
    },
    facebookPageName: "HolyTrinityKileleshwa",
    youtubeChannelHandle: "HolyTrinityCatholicChurchKile",
    youtubeChannelId: "UC_L7tkaF6bYU4hvePq6l72g",
};

// Parish Vision, Mission and Values (COLUS)
export const PARISH_CONTENT = {
    values: {
        heading: "Our Values, COLUS",
        intro:
            "Our Values capture our common beliefs, what we cherish and what we will always be known for. At HTCC, we are a Community of Love, Unity and Service, COLUS.",
        pillars: [
            {
                key: "love",
                title: "Love",
                points: [
                    "We are compassionate",
                    "We are empathetic and caring",
                    "We know one another",
                ],
            },
            {
                key: "unity",
                title: "Unity",
                points: [
                    "We pull together",
                    "We walk together",
                    "We support the Church",
                ],
            },
            {
                key: "service",
                title: "Service",
                points: [
                    "We go the extra mile",
                    "We share our talents, skills and time",
                    "We are witnesses of God\u2019s Word",
                ],
            },
        ],
    },
    vision: {
        heading: "Our Vision",
        body:
            "Our Vision focuses on a Christ-centered, Spirit-led community that joyfully lives and spreads the Gospel, nurtures deep discipleship, and boldly responds to the changing needs of our parish community and the world.",
    },
    mission: {
        heading: "Our Mission",
        intro:
            "Our Mission Statement describes our purpose and our reason for existence. It captures our path to holiness: spiritual growth, self-sacrifice, apostolate, and contributing our part in society. Rooted in the love of Christ and guided by the Holy Spirit, we are a Catholic Community committed to:",
        commitments: [
            "Worshipping God in spirit and in truth through vibrant liturgy and sacramental life;",
            "Forming faithful disciples through on-going catechesis, evangelization and spiritual growth;",
            "Stewarding our gifts with gratitude, responsibility and generosity; and",
            "Responding to human needs with compassion, justice and hope.",
        ],
        closing:
            "Together, we strive to be a beacon of faith, unity and service in our diverse and growing neighbourhoods and beyond.",
        pledge:
            "To foster a spiritually enriching, apostolic and inclusive community where everyone grows in the Faith.",
    },
};

export const ASSETS = {
    logo: "/images/logo.png",
    sanctuary:
        "/images/parish/sanctuary.jpg",
    marianShrine:
        "/images/parish/marian-shrine.jpg",
    sccChart1:
        "/images/parish/scc-chart-1.png",
    sccChart2:
        "/images/parish/scc-chart-2.png",
    pewsBokeh:
        "/images/parish/pews-bokeh.jpg",
    baptismMural:
        "/images/parish/baptism-mural.jpg",
    congregation:
        "/images/parish/congregation.jpg",
    steeple:
        "/images/parish/steeple.jpg",
    procession:
        "/images/parish/procession.jpg",
    massCelebration:
        "/images/parish/mass-celebration.jpg",
    holyWaterFont:
        "/images/parish/holy-water-font.jpg",
    frJohn:
        "/images/clergy/fr-john.png",
    frJob:
        "/images/clergy/fr-job.png",
    frNaphtali: "/images/clergy/fr-naphtali.jpg",
    frMathew:
        "/images/clergy/fr-mathew.jpg",
    frAlbert:
        "/images/clergy/fr-albert.png",
    frCanzian:
        "/images/clergy/fr-canzian.png",
    frSimon:
        "/images/clergy/fr-simon.png",
    frNdirangu:
        "/images/clergy/fr-ndirangu.png",
    frZacchaeus:
        "/images/clergy/fr-zacchaeus.png",
    openingPage:
        "/images/parish/opening-page.jpg",
};

// Parish priests, categorised as provided by the parish.
export const PRIESTS = {
    currentParishPriest: {
        name: "Fr. John",
        role: "Current Parish Priest",
        image: "/images/clergy/fr-john.png",
    },
    currentlyServing: [
        {
            name: "Fr. Jack",
            role: "Currently Serving",
            image: "/images/clergy/fr-jack.png",
            imageFit: "contain",
        },
        {
            name: "Fr. Matthew",
            role: "Currently Serving",
            image: "/images/clergy/fr-mathew.jpg",
            imageFit: "contain",
        },
    ],
    formerParishPriests: [
        {
            name: "Fr. Canzian",
            role: "Former Parish Priest",
            image: "/images/clergy/fr-canzian.png",
        },
        {
            name: "Fr. Fredrick Ndirangu",
            role: "Former Parish Priest",
            image: "/images/clergy/fr-ndirangu.png",
        },
    ],
    formerServing: [
        {
            name: "Fr. Naphtali",
            role: "Former Serving Priest",
            image: "/images/clergy/fr-naphtali.jpg",
        },
        {
            name: "Fr. Job",
            role: "Former Serving Priest",
            image: "/images/clergy/fr-job.png",
        },
        {
            name: "Fr. Zacchaeus Alaroh",
            role: "Former Serving Priest",
            image: "/images/clergy/fr-zacchaeus.png",
        },
        {
            name: "Fr. Albert",
            role: "Former Serving Priest",
            image: "/images/clergy/fr-albert.png",
        },
        {
            name: "Fr. Simon Wambua",
            role: "Former Serving Priest",
            image: "/images/clergy/fr-simon.png",
        },
    ],
};

export const MASS_TIMES = {
    weekdays: {
        label: "Monday – Friday",
        times: [
            { time: "6:45 AM", note: "English Mass" },
            { time: "6:00 PM", note: "English Mass" },
        ],
        confession: "Confession is heard 30 minutes before each weekday Mass.",
    },
    saturday: {
        label: "Saturday",
        times: [
            { time: "9:00 AM", note: "English Mass" },
            { time: "6:00 PM", note: "Vigil Mass (English)" },
        ],
    },
    sunday: {
        label: "Sunday",
        times: [
            { time: "7:00 AM", note: "Kiswahili Mass" },
            { time: "8:30 AM", note: "English Mass" },
            { time: "10:15 AM", note: "English Mass" },
            { time: "12:15 PM", note: "Midday Mass, English" },
            { time: "5:00 PM", note: "English Mass" },
        ],
    },
    publicHolidays: {
        label: "Public Holidays",
        times: [
            { time: "9:00 AM", note: "English Mass" },
        ],
    },
};

// Parish associations / ministries with web-style description
export const CHURCH_GROUPS = [
    {
        code: "CWA",
        name: "Catholic Women Association",
        description:
            "A fellowship of Catholic women devoted to spiritual growth, family life and acts of charity within the parish. The CWA organises retreats, supports vulnerable families and accompanies parish liturgies through prayer and service.",
    },
    {
        code: "PMC",
        name: "Pontifical Missionary Childhood",
        description:
            "Forms our youngest children in the missionary spirit through prayer, sacrifice and learning to share the love of Jesus with others. Founded in 1843, PMC inspires children worldwide with the motto: 'Children helping children.'",
    },
    {
        code: "YSC",
        name: "Young Students Christian Movement",
        description:
            "An apostolate of secondary and college students living their faith in school, family and community, supported by Sunday Mass, recollections, mentorship and acts of outreach to less-fortunate peers.",
        instagram: "https://www.instagram.com/holytrinitykileleshwa_youth/",
    },
    {
        code: "YCA",
        name: "Young Catholic Adults",
        description:
            "A vibrant group of young adults (18–35) growing in faith, friendship and service. YCA bridges youth ministry and adult parish life through Bible studies, social events, retreats and active participation at Mass.",
        instagram: "https://www.instagram.com/holytrinitykileleshwa_youth/",
    },
    {
        code: "CFC",
        name: "Couples for Christ",
        description:
            "Married couples journeying together in Christ-centered family life. Through formation, regular meetings and shared mission, Couples for Christ strengthens marriages, supports parenting and brings the Gospel into the home.",
    },
    {
        code: "CJPD",
        name: "Catholic Justice & Peace Department",
        description:
            "Promotes the social teaching of the Church through justice, peace-building, civic engagement, environmental stewardship and care for the most vulnerable, especially the poor, prisoners and victims of injustice.",
    },
];

// Patron-saint groups within the parish, these also serve as Small Christian Communities (SCCs).
export const PATRON_GROUPS = [
    {
        name: "St. Joseph Allamano",
        description:
            "Italian priest (1851–1926) who founded the Consolata Missionaries and Consolata Missionary Sisters with a vision to bring the Gospel to Africa. The first Consolata missionaries arrived in Kenya in 1902, and his missionary spirit lives on in the East African Church. He was canonized in 2024.",
    },
    {
        name: "St. Therese of the Child Jesus",
        description:
            "Known as 'The Little Flower of Jesus,' she was a Carmelite nun of Lisieux, France (1873–1897) whose 'little way' of doing small things with great love has inspired millions. Though she lived only 24 years and never left her convent, she is the Patroness of the Missions and a Doctor of the Church.",
    },
    {
        name: "Our Lady of Fatima",
        description:
            "In 1917, the Blessed Virgin Mary appeared six times to three shepherd children, Lúcia, Francisco and Jacinta, in Fatima, Portugal. She called the world to prayer, penance and devotion to her Immaculate Heart, and entrusted the well-known three secrets of Fatima. Her feast is celebrated on 13 May.",
    },
    {
        name: "St. Lawrence",
        description:
            "One of the seven deacons under Pope Sixtus II, in charge of giving help to the poor and the needy. He was martyred during the reign of Emperor Valerian in c. 258, tied on top of an iron grill over a slow fire that roasted his flesh little by little, yet burning with so much love of God that he almost did not feel the flames. At the hour of his death he prayed that the city of Rome may be converted to Jesus and that the Catholic Faith may spread all over the world.",
    },
    {
        name: "Our Lady of Mt. Carmel",
        description:
            "The title under which the Blessed Virgin is venerated as patroness of the Carmelite Order, tracing back to the hermits of Mount Carmel in the Holy Land. The Brown Scapular, given by Mary to St. Simon Stock in 1251, remains one of the great Marian devotions of the Church. Her feast is celebrated on 16 July.",
    },
    {
        name: "St. Alphonsus de Liguori",
        description:
            "Italian bishop, moral theologian and Doctor of the Church (1696–1787) who founded the Redemptorists. A pastor of the poor and most abandoned, his writings on prayer, Mary and moral theology have shaped Catholic life for centuries. His feast is 1 August.",
    },
    {
        name: "St. Joseph the Worker",
        description:
            "Foster father of Jesus and Spouse of the Blessed Virgin Mary, declared patron of workers by Pope Pius XII in 1955 as a Christian response to the dignity of labour. His silent, faithful work as a carpenter in Nazareth is the model for the dignity of all human work. His feast falls on 1 May.",
    },
    {
        name: "Blessed Irene Stefani 'Nyaatha'",
        description:
            "Italian-born Consolata Sister (1891–1930) who served as a nurse and missionary in Kenya, becoming so loved by the people of Gekondi (Nyeri) that they called her 'Nyaatha', Mother of Mercy. She gave her life caring for the sick during a smallpox epidemic. She was beatified by Pope Francis in 2015.",
    },
    {
        name: "St. Padre Pio",
        description:
            "Capuchin Franciscan friar and mystic (1887–1968) who bore the wounds of Christ, the stigmata, for fifty years. Renowned for his gift of confession, counsel and the founding of the 'Home for the Relief of Suffering' hospital, he was canonized by Pope John Paul II in 2002. His feast is 23 September.",
    },
    {
        name: "St. Bede",
        description:
            "English Benedictine monk (c. 672–735), Doctor of the Church and 'Father of English History' for his Ecclesiastical History of the English People. A pioneer of biblical study, he is associated with popularising the Anno Domini (A.D.) dating system. Patron of scholars, historians and lectors.",
    },
    {
        name: "St. Francis of Assisi",
        description:
            "Son of a wealthy merchant (1181–1226) who heard the call of the crucified Christ to 'rebuild my Church' and founded the Order of Friars Minor. Lover of the poor, peacemaker and the first known stigmatist, he is the patron of ecology, Italy and animals. His feast is 4 October.",
    },
    {
        name: "St. John of God",
        description:
            "Portuguese soldier (1495–1550) who, after a profound conversion in Granada, dedicated his life to serving the sick and mentally ill. He founded the Brothers Hospitallers, today a worldwide order of religious nurses, and is patron of hospitals, the sick, nurses and booksellers.",
    },
    {
        name: "St. Faustina",
        description:
            "Polish religious sister (1905–1938) of the Congregation of Sisters of Our Lady of Mercy, to whom Jesus revealed the message and image of the Divine Mercy, 'Jesus, I trust in You.' Her Diary remains one of the great mystical texts of the 20th century. She was canonized in the Jubilee Year 2000.",
    },
    {
        name: "Our Lady of Assumption",
        description:
            "Commemorates the dogma defined by Pope Pius XII in 1950: at the end of her earthly life, the Blessed Virgin Mary was assumed body and soul into the glory of Heaven. The Assumption (15 August) is a holy day of obligation and one of the principal feasts of Our Lady.",
    },
    {
        name: "St. Monica",
        description:
            "Mother of St. Augustine (332–387) and model of perseverance in prayer for the conversion of her son and husband. She wept and prayed for years until Augustine was baptized; she died shortly afterwards at Ostia. She is the patron of mothers and of those praying for the conversion of family members.",
    },
    {
        name: "Sacred Heart of Jesus",
        description:
            "Devotion to the love of Christ, symbolised by His pierced and burning Heart, given especially to St. Margaret Mary Alacoque in the 17th century. The Sacred Heart represents the boundless mercy of Jesus and calls the faithful to reparation and consecration. The Solemnity falls on the Friday after Corpus Christi.",
    },
    {
        name: "Our Lady of Perpetual Help",
        description:
            "A beloved Byzantine icon of the Theotokos and Child Jesus, entrusted to the Redemptorists in 1866 by Pope Pius IX with the charge to 'make her known throughout the world.' She is invoked daily for healing, family needs and constant intercession. Her feast is celebrated on 27 June.",
    },
    {
        name: "Immaculate Conception",
        description:
            "Dogma defined by Pope Pius IX in 1854: by a singular grace of God and in view of the merits of Christ, the Blessed Virgin Mary was conceived without original sin from the first moment of her existence. She is patroness of many nations and her solemnity is celebrated on 8 December.",
    },
    {
        name: "St. Rita of Cascia",
        description:
            "Italian Augustinian nun (1381–1457) whose life included a difficult marriage, the loss of her family and acceptance into religious life despite many obstacles. Marked on her forehead by a wound from Christ's crown of thorns, she is invoked as patroness of impossible and difficult causes.",
    },
    {
        name: "St. Paul the Apostle",
        description:
            "Once a persecutor of the Church named Saul, he was converted by an encounter with the Risen Christ on the road to Damascus and became the great Apostle to the Gentiles. His missionary journeys and thirteen New Testament letters shaped Christian theology forever. Martyred in Rome, he is the patron of missionaries.",
    },
    {
        name: "Our Lady Consolata",
        description:
            "Patroness of the Consolata Missionaries, venerated under this title at the great Shrine in Turin, Italy. As 'Mother of Consolation,' she is invoked by missionaries serving in Kenya and across the world. Her feast is celebrated on 20 June.",
    },
    {
        name: "St. Therese of the Child of God",
        description:
            "Patroness for those entrusting themselves to a childlike trust in the Father's love, closely associated with St. Thérèse of Lisieux's spirituality of becoming little. In our parish this community fosters humility, simplicity and a confident, persevering spirit of prayer.",
    },
];

// Keep DEVOTIONAL_GROUPS export for backwards compatibility
export const DEVOTIONAL_GROUPS = PATRON_GROUPS;

// Same patron saints form our 22 Small Christian Communities (SCCs)
export const SCCS = PATRON_GROUPS;

// -------------------------------------------------------------
// Church Groups & Missions, structured for the merged section
// -------------------------------------------------------------

// Ordered list of the parish's Small Christian Communities, matched to
// the saved images at /images/scc/scc-XX.jpg (Runs 2-4).
export const SCCS_LIST = [
    { file: "scc-01.jpg", name: "Our Lady of Mt. Carmel" },
    { file: "scc-02.jpg", name: "Emmanuel" },
    { file: "scc-03.jpg", name: "St. Lawrence" },
    { file: "scc-04.jpg", name: "St. John of God" },
    { file: "scc-05.jpg", name: "St. Joseph the Worker" },
    { file: "scc-06.jpg", name: "St. Monica" },
    { file: "scc-07.jpg", name: "Our Lady of Assumption" },
    { file: "scc-08.jpg", name: "St. Francis of Assisi" },
    { file: "scc-09.jpg", name: "St. Faustina Kowalska" },
    { file: "scc-10.jpg", name: "St. Alphonsus de Liguori" },
    { file: "scc-11.jpg", name: "Blessed Sr. Irene" },
    { file: "scc-12.jpg", name: "St. Therese of the Child Jesus" },
    { file: "scc-13.jpg", name: "St. Joseph Allamano" },
    { file: "scc-14.jpg", name: "St. Padre Pio" },
    { file: "scc-15.jpg", name: "Our Lady of Fatima" },
].map((s, i) => {
    // Lookup a description from PATRON_GROUPS by loose name match (fallback = generic SCC blurb)
    const canon = PATRON_GROUPS.find(
        (p) =>
            p.name.toLowerCase().replace(/[^a-z]/g, "") ===
                s.name.toLowerCase().replace(/[^a-z]/g, "") ||
            p.name.toLowerCase().includes(s.name.toLowerCase().split(" ").slice(-2).join(" ").toLowerCase())
    );
    return {
        id: `scc-${String(i + 1).padStart(2, "0")}`,
        image: `/images/scc/${s.file}`,
        name: s.name,
        description:
            canon?.description ||
            `A neighbourhood Small Christian Community of Holy Trinity Kileleshwa Parish gathered under the patronage of ${s.name}. Members meet weekly to pray, share Scripture and walk with one another in daily Christian life.`,
    };
});

// Ministries
export const MINISTRIES = [
    {
        code: "CHOIR",
        name: "Choir",
        description:
            "The parish choir animates our liturgies with sacred music, leading the congregation in psalms, hymns and Spirit-filled song. Choristers rehearse weekly and serve at all Sunday Masses and major feasts.",
    },
    {
        code: "PROCLAIMERS",
        name: "St. Bede Proclaimers",
        description:
            "The ministry of lectors and readers who proclaim the Word of God at Mass. Trained in scripture, diction and reverence, members serve on a rota across weekday and weekend liturgies.",
    },
    {
        code: "CJPD",
        name: "CJPD, Catholic Justice & Peace Department",
        description:
            "Promotes the social teaching of the Church through justice, peace-building, civic engagement, environmental stewardship and care for the most vulnerable, especially the poor, prisoners and victims of injustice.",
    },
];

// Associations, cards may carry an image (CWA/CMA) or an icon key
export const ASSOCIATIONS_LIST = [
    {
        code: "CWA",
        name: "Catholic Women Association",
        image: "/images/associations/cwa.jpg",
        description:
            "A fellowship of Catholic women devoted to spiritual growth, family life and acts of charity within the parish. The CWA organises retreats, supports vulnerable families and accompanies parish liturgies through prayer and service.",
    },
    {
        code: "CMA",
        name: "Catholic Men Association",
        image: "/images/associations/cma.jpg",
        description:
            "Men of Faith, a brotherhood committed to holiness in family, work and society. The CMA gathers for prayer, formation and parish service, forming disciples who lead with integrity in the home and the world.",
    },
    {
        code: "CFC",
        name: "Couples for Christ",
        image: "/images/associations/cfc.jpg",
        description:
            "Married couples journeying together in Christ-centered family life. Through formation, regular meetings and shared mission, Couples for Christ strengthens marriages, supports parenting and brings the Gospel into the home.",
    },
    {
        code: "PMC",
        name: "Pontifical Missionary Children",
        image: "/images/associations/pmc.jpg",
        description:
            "Forms our youngest children in the missionary spirit through prayer, sacrifice and learning to share the love of Jesus with others. Founded in 1843, PMC inspires children worldwide with the motto: 'Children helping children.'",
    },
    {
        code: "MYM",
        name: "Missionary Youth Movement",
        image: "/images/associations/mym.jpg",
        description:
            "Teens and young people formed for mission, witnessing to Christ in schools, neighbourhoods and social media. MYM meets for catechesis, service and joyful fellowship rooted in the missionary heart of the Church.",
    },
    {
        code: "YSC",
        name: "Youth Serving Christ",
        image: "/images/associations/ysc.jpg",
        description:
            "An apostolate of secondary and college youth living their faith in school, family and community, sustained by Sunday Mass, recollections, mentorship and acts of outreach to less-fortunate peers.",
        instagram: "https://www.instagram.com/holytrinitykileleshwa_youth/",
    },
    {
        code: "YCA",
        name: "Young Catholic Adults",
        image: "/images/associations/yca.jpg",
        description:
            "A vibrant group of young adults (18–35) growing in faith, friendship and service. YCA bridges youth ministry and adult parish life through Bible studies, socials, retreats and active participation at Mass.",
        instagram: "https://www.instagram.com/holytrinitykileleshwa_youth/",
    },
];

// Sodalities
export const SODALITIES = [
    {
        code: "SHJ",
        name: "Sacred Heart of Jesus",
        description:
            "Devotion to the love of Christ, symbolised by His pierced and burning Heart, given especially to St. Margaret Mary Alacoque in the 17th century. Members consecrate themselves to the Sacred Heart through First Friday devotions, Adoration and works of reparation.",
    },
];

// Local photos saved under /public/images/photos, used by Gallery + Home slideshow
export const LOCAL_PHOTOS = [
    {
        src: "/images/photos/gallery-5.jpg",
        alt: "Inside the parish, the timber ceiling, sanctuary and pews at Holy Trinity Kileleshwa",
        caption: "Our parish church, gathered for prayer",
        w: 1200,
        h: 1610,
    },
    {
        src: "/images/photos/gallery-4.jpg",
        alt: "The grand front doors of Holy Trinity Catholic Church, Kileleshwa",
        caption: "\u2018HTCC\u2019 \u2014 the front entrance to the parish",
        w: 1200,
        h: 1567,
    },
    {
        src: "/images/photos/gallery-3.jpg",
        alt: "Statue of Our Lady of the Assumption in the parish",
        caption: "Our Lady of the Assumption \u2014 patron of one of our SCCs",
        w: 1200,
        h: 1626,
    },
    {
        src: "/images/photos/gallery-1.jpg",
        alt: "The confessional inside Holy Trinity Kileleshwa Parish",
        caption: "The sacrament of Reconciliation \u2014 mercy that awaits",
        w: 1200,
        h: 1606,
    },
    {
        src: "/images/photos/gallery-2.jpg",
        alt: "The parish baptismal font, adorned in blue mosaic",
        caption: "Baptismal font \u2014 where we are made children of God",
        w: 1200,
        h: 1627,
    },
    {
        src: "/images/photos/gallery-9.jpg",
        alt: "Aerial view of Holy Trinity Catholic Church, Kileleshwa",
        caption: "Our parish home \u2014 Othaya Road, Kileleshwa",
        w: 1600,
        h: 1200,
    },
    {
        src: "/images/photos/gallery-8.jpg",
        alt: "Parishioners at Mass inside the wooden-ceilinged sanctuary",
        caption: "The People of God at prayer",
        w: 1600,
        h: 1064,
    },
    {
        src: "/images/photos/gallery-6.jpg",
        alt: "The parish steeple with 'He Is Risen' Easter banner beside the gate",
        caption: "\u2018He is Risen\u2019 \u2014 Easter at Holy Trinity",
        w: 900,
        h: 1200,
    },
    {
        src: "/images/photos/gallery-7.jpg",
        alt: "The Marian grotto and prayer path in the parish grounds",
        caption: "The Marian grotto \u2014 a place of quiet intercession",
        w: 1600,
        h: 1064,
    },
    {
        src: "/images/photos/gallery-10.jpg",
        alt: "Ornate tabernacle detail with sunburst and Eucharistic emblem",
        caption: "Adoration of the Blessed Sacrament",
        w: 900,
        h: 1200,
    },
];

// -------------------------------------------------------------
// Events (Upcoming + Past). Structured for future additions.
// -------------------------------------------------------------
export const UPCOMING_EVENTS = [];

export const PAST_EVENTS = [
    {
        id: "archdiocese-family-day-2026",
        title: "Archdiocese Family Day",
        image: "/images/events/event-1.jpg",
        description:
            "Parishes across the Archdiocese of Nairobi gathered at the Loreto Convent Msongari School Grounds to celebrate faith, family and community, a joyful day of Holy Mass, fellowship and shared testimony.",
    },
    {
        id: "family-day-kenya-high-2026",
        title: "Family Day",
        image: "/images/events/event-2.jpg",
        description:
            "Holy Trinity Kileleshwa's parish-wide Family Day at Kenya High School, a celebration of the Lord's blessings upon our parish families, with Holy Mass, Confirmation, activities for children and fellowship for all.",
    },
    {
        id: "amecea-youth-mass-2026",
        title: "AMECEA Youth Mass",
        image: "/images/events/event-3.jpg",
        description:
            "The 21st AMECEA Plenary Assembly Youth Mass at the Catholic University of Eastern Africa, a Spirit-filled gathering of young Catholics from across Eastern Africa in liturgy, praise and mission.",
    },
];

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/groups", label: "Church Groups & Missions" },
    { to: "/events", label: "Events & Calendar" },
    { to: "/community", label: "Community" },
    { to: "/live", label: "Live Stream" },
    { to: "/gallery", label: "Photos" },
    { to: "/contact", label: "Contact" },
];

// Secondary links exposed inside the Community Hub
export const COMMUNITY_LINKS = [
    { to: "/prayer-wall", label: "Prayer Wall" },
    { to: "/blogs", label: "Blogs" },
];

// Common Catholic Prayers
export const COMMON_PRAYERS = [
    {
        slug: "sign-of-the-cross",
        name: "The Sign of the Cross",
        text: `In the name of the Father, and of the Son, and of the Holy Spirit. Amen.`,
    },
    {
        slug: "our-father",
        name: "The Our Father",
        text: `Our Father, who art in heaven,
hallowed be thy name;
thy kingdom come,
thy will be done on earth as it is in heaven.
Give us this day our daily bread,
and forgive us our trespasses,
as we forgive those who trespass against us;
and lead us not into temptation,
but deliver us from evil. Amen.`,
    },
    {
        slug: "hail-mary",
        name: "The Hail Mary",
        text: `Hail Mary, full of grace, the Lord is with thee;
blessed art thou amongst women,
and blessed is the fruit of thy womb, Jesus.
Holy Mary, Mother of God,
pray for us sinners,
now and at the hour of our death. Amen.`,
    },
    {
        slug: "glory-be",
        name: "Glory Be (Doxology)",
        text: `Glory be to the Father, and to the Son, and to the Holy Spirit.
As it was in the beginning, is now, and ever shall be, world without end. Amen.`,
    },
    {
        slug: "apostles-creed",
        name: "The Apostles' Creed",
        text: `I believe in God, the Father almighty, Creator of heaven and earth,
and in Jesus Christ, his only Son, our Lord,
who was conceived by the Holy Spirit, born of the Virgin Mary,
suffered under Pontius Pilate, was crucified, died and was buried;
he descended into hell; on the third day he rose again from the dead;
he ascended into heaven, and is seated at the right hand of God the Father almighty;
from there he will come to judge the living and the dead.
I believe in the Holy Spirit, the holy catholic Church,
the communion of saints, the forgiveness of sins,
the resurrection of the body, and life everlasting. Amen.`,
    },
    {
        slug: "act-of-contrition",
        name: "Act of Contrition",
        text: `O my God, I am heartily sorry for having offended Thee,
and I detest all my sins because of Thy just punishments,
but most of all because they offend Thee, my God,
who art all good and deserving of all my love.
I firmly resolve, with the help of Thy grace,
to sin no more and to avoid the near occasion of sin. Amen.`,
    },
    {
        slug: "act-of-spiritual-communion",
        name: "An Act of Spiritual Communion",
        text: `My Jesus,
I believe that You are present in the Most Holy Sacrament.
I love You above all things,
and I desire to receive You into my soul.
Since I cannot at this moment receive You sacramentally,
come at least spiritually into my heart.
I embrace You as if You were already there
and unite myself wholly to You.
Never permit me to be separated from You.
Amen.`,
    },
    {
        slug: "memorare",
        name: "The Memorare",
        text: `Remember, O most gracious Virgin Mary,
that never was it known that anyone who fled to thy protection,
implored thy help, or sought thy intercession was left unaided.
Inspired by this confidence, I fly unto thee, O Virgin of virgins, my Mother;
to thee do I come, before thee I stand, sinful and sorrowful.
O Mother of the Word Incarnate, despise not my petitions,
but in thy mercy hear and answer me. Amen.`,
    },
    {
        slug: "hail-holy-queen",
        name: "Hail Holy Queen (Salve Regina)",
        text: `Hail, Holy Queen, Mother of Mercy, our life, our sweetness, and our hope.
To thee do we cry, poor banished children of Eve;
to thee do we send up our sighs, mourning and weeping in this valley of tears.
Turn, then, most gracious advocate, thine eyes of mercy toward us,
and after this our exile, show unto us the blessed fruit of thy womb, Jesus.
O clement, O loving, O sweet Virgin Mary. Amen.`,
    },
    {
        slug: "angel-of-god",
        name: "Angel of God (Guardian Angel)",
        text: `Angel of God, my guardian dear,
to whom God's love commits me here,
ever this day be at my side,
to light and guard, to rule and guide. Amen.`,
    },
    {
        slug: "prayer-to-st-michael",
        name: "Prayer to St. Michael the Archangel",
        text: `Saint Michael the Archangel, defend us in battle.
Be our protection against the wickedness and snares of the devil.
May God rebuke him, we humbly pray;
and do thou, O Prince of the heavenly host,
by the power of God, cast into hell Satan and all evil spirits
who prowl about the world seeking the ruin of souls. Amen.`,
    },
    {
        slug: "anima-christi",
        name: "Anima Christi (Soul of Christ)",
        text: `Soul of Christ, sanctify me.
Body of Christ, save me.
Blood of Christ, inebriate me.
Water from the side of Christ, wash me.
Passion of Christ, strengthen me.
O good Jesus, hear me.
Within Thy wounds hide me.
Permit me not to be separated from Thee.
From the wicked foe defend me.
At the hour of my death call me
and bid me come to Thee,
that with Thy saints I may praise Thee
for ever and ever. Amen.`,
    },
    {
        slug: "grace-before-meals",
        name: "Grace Before Meals",
        text: `Bless us, O Lord, and these Thy gifts which we are about to receive
from Thy bounty, through Christ our Lord. Amen.`,
    },
];
